import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import Home from './pages/Home';
import RankingDetail from './pages/RankingDetail';
import RankingsPage from './pages/RankingsPage';
// 导入其他页面组件
const logo = require('./assets/logo.png');
import './styles/main.css';

const App: React.FC = () => {
  return (
    <Router>
      {/* 顶部导航条在所有页面共享 */}
      <div className="top-nav-bar">
        <div className="nav-container">
          <div className='nav-info'>
            <img src={logo} className="nav-logo" alt="logo" />
            <span className="nav-title">D站</span>
          </div>
          <div className="nav-links">
            <a href="https://docs.dooocs.com" className="nav-link">文档</a>
            <Link to="/" className="nav-link">首页</Link>
          </div>
        </div>
      </div>

      {/* 路由配置 */}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/ranking/:id" element={<RankingDetail />} />
        <Route path="/rankings" element={<RankingsPage />} />
        {/* 其他路由 */}
      </Routes>
    </Router>
  );
};

export default App; 